<template>
  <div>
    <v-row class="d-flex justify-space-between">
      <v-col class="pl-10">
        <v-switch
          inset
          v-model="hideContingent"
          label="Hide Contingent Workers"
        ></v-switch>
      </v-col>
      <v-col class="pr-10">
        <v-text-field
          class="pb-5"
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="clearances"
          :search="search"
        >
          <template v-slot:item.avatar="{ item }" >
            <Avatar 
              :employee="item.employee"
              :size="30"
              :hideHeadline="true"
            />
          </template>
          <template v-slot:item.fields.Name="{ item }" >
            <div v-if="item.employee && item.employee.id">
              <router-link
                :to="{ name: 'Employee', 
                      params: { id: item.employee.id }
                    }"
              >
              {{ item.fields.Name }}
              </router-link>
            </div>
            <div v-else>
              {{ item.fields.Name }}
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Avatar from '@/components/employee/Avatar'

export default {
  name: 'PermClearanceTable',
  
  components: {
    Avatar
  },

  data: () => ({
    search: '',
    avatarSize: 50,
    headers: [
      {
        text: '',
        sortable: false,
        value: 'avatar'
      },
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'fields.Name'
      },
      {
        text: 'Title',
        align: 'start',
        sortable: true,
        value: 'employee.fields.Title'
      },
      {
        text: 'Department',
        align: 'start',
        sortable: true,
        value: 'employee.fields.Department'
      },
    ],
    hideContingent: false
  }),

  computed: {
    loading () {
      return this.employees.length === 0 || !this.clearances
    },
    employees () {
      return this.$store.getters.getEmployees
    },
    getInitials (name) {
      console.log(name)
      const i = name.match(/\b\w/g) || []
      return ((i.shift() || '') + (i.pop() || '')).toUpperCase()
    },
    clearances () {
      let clearances = this.$store.getters.getClearances.map(c => {
        const employee = this.employees.find(e => {
          if (c.fields.Employee) {
            return c.fields.Employee[0] === e.id
          } else {
            return null
          }
        })

        if (employee) {
          c.employee = employee
        } else {
          // for avatars
          c.employee = {
            fields: {
              Name: c.fields['Non-Employee']
            }
          }
        }
        c.computedValidity = true
        c.computedValidityInLA = true
        c.fields['Valid Until'] = 'Indefinitely'
        c.fields['Valid_in_LA_Until'] = 'Indefinitely'
        return c
      })
      let tests = this.$store.getters.getTests.filter(t => t.fields.Type === 'Permanent').map(t => {
        const employee = this.employees.find(e => {
          if (t.fields.Employee) {
            return t.fields.Employee[0] === e.id
          } else {
            return null
          }
        })
        
        if (employee) {
          t.employee = employee
        } else {
          // for avatars
          t.employee = {
            fields: {
              Name: t.fields['Non-Employee']
            }
          }
        }
        
        t.computedValidity = t.fields.Valid === 1
        t.computedValidityInLA = t.fields['Valid_in_LA'] === 1
        return t
      }).sort((a, b) => {
        return a.fields.Date > b.fields.Date ? -1 : 1
      })
      let result = tests.concat(clearances)
      if (this.hideContingent) {
        result = result.filter(t => {
          return t.fields['Is In ADP']
        })
      }
      return result
    }
  }
}
</script>
